import { useEffect } from 'react'
import { useFilters } from './use-filters'
import { usePaginationSelectors } from './use-pagination-store'

export const useResetPaginationOnMount = () => {
  const { filters } = useFilters()
  const { resetPagination } = usePaginationSelectors({ pageSize: filters.pageSize })

  useEffect(() => {
    // Reset pagination when returning to consignments listing page
    // This ensures users see a consistent view after navigating from consignment processing pages
    resetPagination()
    // Empty dependency array to run only once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
